import React from 'react';
import { Label } from 'quanta-ui';

export default function InsuranceSummaryMinimized({
  lobCode,
  lobName,
  productName,
  productCode,
  planName,
  planCode,
  proposalNumber,
}) {
  return (
    <div className="bg-neutral h-24 w-32 flex justify-center items-center shadow-t shadow-b p-4">
      <Label
        text={
          <span className="text-primary font-bold">
            Coverage Details
          </span>
        }
        severity="info"
      >
        {/*{planName}*/}
      </Label>
    </div>
  );
}
